import { lazy, Suspense, useCallback, useState } from "react";
import GenericFlyout from "../modal/GenericFlyout";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import "./search-dropdown.scss";
import { Spinner } from "reactstrap";

const SearchContent = lazy(() =>
  import("../../pages/SearchPage").then(module => ({
    default: module.SearchContent
  }))
);

const SearchDropdown = () => {
  const t = useBjelinTranslations();
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const closeSearchDropdown = useCallback(
    () => setShowSearchDropdown(false),
    []
  );
  const toggleSearchDropdown = useCallback(
    () => setShowSearchDropdown(showSearchDropdown => !showSearchDropdown),
    []
  );
  return (
    <>
      <button
        id="search-menu-button"
        title={t("menu.tooltip.search")}
        aria-haspopup="dialog"
        className="nav-link"
        style={{
          backgroundColor: showSearchDropdown ? "#fff" : "transparent",
          border: 0
        }}
        aria-expanded={showSearchDropdown}
        onClick={toggleSearchDropdown}
      >
        <Icon name="magnifying-glass" className="icon" />
      </button>
      <GenericFlyout
        id="search-dropdown"
        isOpen={showSearchDropdown}
        close={closeSearchDropdown}
        excludeFromClose="search-menu-button"
        align={"top"}
        noCloseBtn={true}
        width={52}
        ariaLabel={t("search")}
      >
        <div className={"px-4 py-3 search-dropdown-content"}>
          <Suspense fallback={<Spinner />}>
            <SearchContent displayAsOverlay toggle={toggleSearchDropdown} />
          </Suspense>
        </div>
      </GenericFlyout>
    </>
  );
};

export default SearchDropdown;
